import {GlobalStore} from "../global";

export class AuditReducer extends GlobalStore {



}